import Vue from 'vue'

export default{
    getCocinas(parametros){
        return Vue.axios.get("comida-cocina/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getCocina(id){
        return Vue.axios.get("comida-cocina/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updateCocina(parametros){
        return Vue.axios.put("comida-cocina", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    deleteCocina(id){
        return Vue.axios.delete("comida-cocina/"+ id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    addCocina(parametros){
        return Vue.axios.post("comida-cocina", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },    
}